import React from 'react';
import About from './About';
import Skill from './Skill';
import Project from './Project';
import Contact from './Contact';

export default function Main(){
    return(
        <main>
        <About />
        <Skill />
        <Project />
        <Contact />
        </main>
    )
}